<template>
    <ElTooltip content="跳转到元素的源码" placement="left">
        <div
            class="vue-element-inspector"
            :class="{ 'active': isShow }"
            :[ignoreKey]="true"
            @click.stop.capture="isShow = !isShow"
        >
            <SvgIcon icon="SolidSynapseTarget" class="w-4 h-4 fill-current" />
            <span v-if="isShow">按ESC取消</span>
        </div>
    </ElTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SvgIcon from '@telecom/shared/components/SvgIcon.vue';
import type { VueInspectorClient } from 'vite-plugin-vue-inspector';
import { onKeyStroke } from '@vueuse/core';
import { ElTooltip } from 'element-plus';
import '@patsnap-ui/icon/assets/solid/SynapseTarget.svg';

// @ts-ignore
const inspector: VueInspectorClient = window.__VUE_INSPECTOR__;
// @ts-ignore
const ignoreKey = inspector.KEY_IGNORE;

const isShow = computed({
    get() {
        return inspector.enabled;
    },
    set(value) {
        if (value) {
            inspector.enable();
        } else {
            inspector.disable();
        }
    },
});

onKeyStroke('Escape', () => {
    isShow.value = false;
});
</script>

<style lang="scss">
.vue-element-inspector {
    @apply fixed bottom-16 right-0 border border-r-0 z-[100000] p-1 cursor-pointer shadow-sm bg-white border-gray-40 rounded-l-full gap-2 flex items-center text-xs;
    &.active {
        @apply bg-green-500 text-white;
    }
}
</style>
